module.exports = ".table-responsive {\n  max-height: 400px; }\n  .table-responsive .table {\n    margin-bottom: 0; }\n  .table-responsive .table tr td {\n      cursor: pointer; }\n  .table-responsive .table tr:last-child td {\n      border-bottom: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./apps/eyewatch/src/app/eyewatch/observations/widgets/open-observations/open-observations.component.scss
// module id = ./apps/eyewatch/src/app/eyewatch/observations/widgets/open-observations/open-observations.component.scss
// module chunks = main